/** Per-user UI text scale (synced like theme / language). */
export const FONT_SCALE_IDS = ["xs", "sm", "md", "lg", "xl"] as const;
export type FontScaleId = (typeof FONT_SCALE_IDS)[number];

export const FONT_SCALE_VALUES: Record<FontScaleId, number> = {
  xs: 0.875,
  sm: 0.9375,
  md: 1,
  lg: 1.125,
  xl: 1.25,
};

const STORAGE_KEY = "cpl_font_scale";

export function isFontScaleId(value: unknown): value is FontScaleId {
  return typeof value === "string" && (FONT_SCALE_IDS as readonly string[]).includes(value);
}

export function migrateFontScale(stored: string | null): FontScaleId {
  if (isFontScaleId(stored)) return stored;
  return "md";
}

export function readStoredFontScale(): FontScaleId {
  try {
    return migrateFontScale(localStorage.getItem(STORAGE_KEY));
  } catch {
    return "md";
  }
}

export function writeStoredFontScale(id: FontScaleId): void {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    /* ignore */
  }
}

export function applyFontScaleToDocument(id: FontScaleId): void {
  const root = document.documentElement;
  const scale = FONT_SCALE_VALUES[id];
  root.style.setProperty("--app-text-scale", String(scale));
  root.setAttribute("data-font-scale", id);
}
